module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conatiner"
  }, [_c('el-row', {
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0",
      "position": "absolute",
      "z-index": "300",
      "background": "#535353",
      "width": "100%"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "logo fl"
  }, [_c('embed', {
    staticClass: "logo-svg",
    attrs: {
      "src": _vm.logo
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 16
    }
  }, [_c('ul', {
    staticClass: "breadcrum",
    staticStyle: {
      "display": "inline-block"
    }
  }, _vm._l((_vm.breadcrumData), function(item) {
    return _c('li', {
      key: item.type,
      class: {
        'li-active': item.type === _vm.active
      },
      on: {
        "click": function($event) {
          _vm.breadcrumClick(item.type)
        }
      }
    }, [_c('span', {
      class: ['iconfont', item.icon]
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(item.text))])])
  }))]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "height": "48px",
      "line-height": "48px",
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                " + _vm._s(_vm.userName)), _c('i', {
    staticClass: "iconfont icon-icon21",
    staticStyle: {
      "fontSize": "10px",
      "marginLeft": "12px"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.role == '1') ? _c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showDialogProfile = true
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-user "
  }), _vm._v("我的主页")])]) : _vm._e(), _vm._v(" "), (_vm.role == '1') ? _c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showMoniRole = true
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-Monitor iconfont",
    staticStyle: {
      "margin-top": "-10px"
    }
  }), _vm._v("监控权限")])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.apiDilog = true
      }
    }
  }, [_c('i', {
    staticClass: "icon el-icon-tickets",
    staticStyle: {
      "margin-top": "4px"
    }
  }), _vm._v("API认证")])]), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logoutHandler
    }
  }, [_c('i', {
    staticClass: "icon icon-layout "
  }), _vm._v("退出登录 ")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "监控权限",
      "visible": _vm.showMoniRole
    },
    on: {
      "update:visible": function($event) {
        _vm.showMoniRole = $event
      }
    }
  }, [_c('el-form', {
    ref: "formMoniRole",
    staticClass: "tab-modify-pwd",
    attrs: {
      "model": _vm.moniRole,
      "rules": _vm.rulesMoniPwd
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-err",
    attrs: {
      "label": "监控权限密码",
      "label-width": "120px",
      "prop": "new"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.moniRole.new),
      callback: function($$v) {
        _vm.$set(_vm.moniRole, "new", $$v)
      },
      expression: "moniRole.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-err",
    attrs: {
      "label": "确认密码",
      "label-width": "120px",
      "prop": "newConfirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.moniRole.newConfirm),
      callback: function($$v) {
        _vm.$set(_vm.moniRole, "newConfirm", $$v)
      },
      expression: "moniRole.newConfirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-bott"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showMoniRole = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-save-profile",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveMoniRole('formMoniRole')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "个人信息",
      "visible": _vm.showDialogProfile
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialogProfile = $event
      }
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "formEditProfileInfo",
    attrs: {
      "model": _vm.profile.info,
      "rules": _vm.rulesProfileBase
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱账号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名/昵称",
      "label-width": _vm.formLabelWidth,
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.profile.info.userName),
      callback: function($$v) {
        _vm.$set(_vm.profile.info, "userName", $$v)
      },
      expression: "profile.info.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-bott"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialogProfile = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-save-profile",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveProfileBaseHandler('formEditProfileInfo')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "修改密码",
      "name": "second"
    }
  }, [_c('el-form', {
    ref: "formEditProfilePwd",
    staticClass: "tab-modify-pwd",
    attrs: {
      "model": _vm.profile.pwd,
      "rules": _vm.rulesProfilePwd
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "label-width": _vm.formLabelWidth,
      "prop": "old"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.profile.pwd.old),
      callback: function($$v) {
        _vm.$set(_vm.profile.pwd, "old", $$v)
      },
      expression: "profile.pwd.old"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-err",
    attrs: {
      "label": "新密码",
      "label-width": _vm.formLabelWidth,
      "prop": "new"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.profile.pwd.new),
      callback: function($$v) {
        _vm.$set(_vm.profile.pwd, "new", $$v)
      },
      expression: "profile.pwd.new"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-err",
    attrs: {
      "label": "确认密码",
      "label-width": _vm.formLabelWidth,
      "prop": "newConfirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.profile.pwd.newConfirm),
      callback: function($$v) {
        _vm.$set(_vm.profile.pwd, "newConfirm", $$v)
      },
      expression: "profile.pwd.newConfirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-bott"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialogProfile = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-save-profile",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.saveProfilePwdHandler('formEditProfilePwd')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "api-secret-dialog",
    attrs: {
      "title": "API认证信息管理",
      "visible": _vm.apiDilog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.apiDilog = $event
      }
    }
  }, [_c('div', {
    staticClass: "border"
  }), _vm._v(" "), _c('el-form', {
    ref: "formData1",
    staticClass: "el--jtk-suite-form-item",
    attrs: {
      "rules": _vm.rules,
      "label-position": "right",
      "model": _vm.node,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "API Access ID"
    }
  }, [_c('div', {
    staticClass: "el-input__inner",
    staticStyle: {
      "width": "400px",
      "overflow-x": "auto",
      "overflow-y": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.node.appKey))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "API Access Secret"
    }
  }, [_c('div', {
    staticClass: "el-input__inner",
    staticStyle: {
      "width": "400px",
      "overflow-x": "auto",
      "overflow-y": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.node.secretKey))]), _vm._v(" "), (_vm.tipWarn) ? _c('div', {
    staticStyle: {
      "color": "#E97A2F"
    }
  }, [_vm._v("生成新的API认证信息后，之前的会作废，继续？")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', [(!_vm.reset) ? _c('el-button', {
    style: (_vm.buttonStyle),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSecret
    }
  }, [_vm._v("生成")]) : _vm._e(), _vm._v(" "), (_vm.tipWarn) ? _c('div', [_c('el-button', {
    style: (_vm.buttonStyle),
    on: {
      "click": function($event) {
        _vm.tipWarn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    style: (_vm.buttonStyle),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSecret
    }
  }, [_vm._v("确认")])], 1) : _vm._e(), _vm._v(" "), (_vm.reset && !_vm.tipWarn) ? _c('el-button', {
    style: (_vm.buttonStyle),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.tipWarn = true
      }
    }
  }, [_vm._v("重新生成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    style: (_vm.buttonStyle),
    on: {
      "click": function($event) {
        _vm.apiDilog = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4958797c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/headNew.vue
// module id = 330
// module chunks = 15